import React from 'react';
import {Grid} from "@mui/material";
import {styled} from "@mui/material/styles";
import {DateRangePicker} from "react-dates";

import {ReactComponent as Location} from "assets/img/location.svg";
import {ReactComponent as Call} from "assets/img/call.svg";
import {ReactComponent as Sms} from "assets/img/sms.svg";
import {ReactComponent as Calendar} from "assets/img/calendar.svg";
import {ReactComponent as PrinterIcon} from "assets/img/whiteOutlinedPrinter.svg";
import {greyishBlue200, greyishBlue300, greyishBlue400} from "assets/jss/main";
import SearchBar from "components/List/components/SearchBar";
import SearchIcon from "components/icons/SearchIcon";
import CustomButton from "components/CustomButton";

const ShortcutHint = styled('span')({
    color: greyishBlue400,
    fontSize: '14px',
    whiteSpace: 'nowrap',
    paddingRight: '16px'
});

const StyledDateRangePicker = styled('div')({
    '.DateRangePickerInput': {
        whiteSpace: 'nowrap',
        maxWidth: '300px',
        height: '40px',
        display: 'flex',
        alignItems: 'center',
    },
    '.DateInput': {
        maxWidth: '80px',
    },
    '.DateInput_input': {
        maxWidth: '80px',
        fontWeight: 600,
        fontSize: '14px',
        padding: 0,
        lineHeight: '16px',
    },
    '.DateRangePickerInput__withBorder': {
        borderRadius: '8px',
        border: '1px solid',
        borderColor: greyishBlue200
    },
    '.DateRangePickerInput_arrow': {},
    '.DateRangePickerInput_arrow_svg': {
        fill: 'black',
        width: '20px',
        height: '20px',
    },
    '.DateRangePickerInput_calendarIcon': {
        padding: 0,
        margin: '0 8px 0 16px',
        width: '16px',
        height: '16px'
    },
    '.DateRangePickerInput_clearDates': {
        padding: 0,
        margin: '0 16px 0 8px',
        width: '16px',
        height: '16px',
        position: 'static !important',
        transform: 'none !important',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        lineHeight: 0,
    },
    '.DateRangePickerInput_clearDates_svg': {
        fill: greyishBlue400,
        width: '16px',
        height: '16px',
        display: 'block',
    }
});

function SubtitleRow(type, content) {
    return (
        <Grid container columnSpacing={1} alignItems="center" flexWrap={'nowrap'}>
            {'location' === type && (
                <Grid item sx={{display: 'flex'}}>
                    <Location color={greyishBlue300}/>
                </Grid>
            )}
            {'phone' === type && (
                <Grid item sx={{display: 'flex'}}>
                    <Call/>
                </Grid>
            )}
            {'email' === type && (
                <Grid item sx={{display: 'flex'}}>
                    <Sms/>
                </Grid>
            )}
            <Grid item>
                {content}
            </Grid>
        </Grid>
    );
}

function RetailerPickingListHeader({
    retailer,
    isMac,
    searchInputRef,
    onSearchChange,
    dateRange,
    onDatesChange,
    focusedInput,
    onFocusChange,
    onDateClose,
    onOkClick,
}) {
    return (
        <Grid container justifyContent="space-between" alignItems="flex-start">
            <Grid item sx={{maxWidth: '350px'}}>
                <strong>{retailer?.name}</strong>
                <Grid container direction="column" sx={{marginTop: '8px'}}>
                    {SubtitleRow('location', <span>{retailer?.address}, {retailer?.addressVO?.postalCode}, {retailer?.addressVO?.city}</span>)}
                    {SubtitleRow('phone', <span>{retailer?.phone}</span>)}
                    {SubtitleRow('email', <span>{retailer?.email}</span>)}
                </Grid>
            </Grid>

            <Grid item sx={{flexGrow: 1}}>
                <Grid container columnSpacing={1} flexWrap="nowrap">
                    <Grid item sx={{flexGrow: 1}}>
                        <SearchBar
                            id="search-input"
                            inputRef={searchInputRef}
                            customPlaceholder="retailer.picking.list.search.placeholder"
                            onChange={(value) => onSearchChange(value)}
                            InputProps={{
                                startAdornment: <SearchIcon size={25}/>,
                            }}
                            style={{
                                borderColor: greyishBlue200,
                                '& .MuiInputBase-root': {
                                    height: '40px',
                                    width: '100%',
                                    input: {
                                        padding: '0 16px',
                                    },
                                },
                            }}
                        />
                    </Grid>

                    <Grid item>
                        <StyledDateRangePicker>
                            <DateRangePicker
                                startDateId="startDate"
                                endDateId="endDate"
                                startDatePlaceholderText="--/--/--"
                                endDatePlaceholderText="--/--/--"
                                startDate={dateRange.startDate}
                                endDate={dateRange.endDate}
                                onDatesChange={onDatesChange}
                                focusedInput={focusedInput}
                                onFocusChange={onFocusChange}
                                onClose={onDateClose}
                                displayFormat="DD/MM/YY"
                                block={true}
                                showClearDates={true}
                                reopenPickerOnClearDates={true}
                                hideKeyboardShortcutsPanel={true}
                                withFullScreenPortal={window.innerWidth < 768}
                                numberOfMonths={2}
                                orientation={window.innerWidth < 768 ? "vertical" : "horizontal"}
                                anchorDirection="right"
                                minimumNights={0}
                                isOutsideRange={() => false}
                                customInputIcon={<Calendar/>}
                            />
                        </StyledDateRangePicker>
                    </Grid>

                    <Grid item>
                        <CustomButton onClick={onOkClick}>
                            <PrinterIcon />
                        </CustomButton>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default RetailerPickingListHeader;